import { render, staticRenderFns } from "./LoginReportes.vue?vue&type=template&id=ef5911ee&"
import script from "./LoginReportes.vue?vue&type=script&lang=js&"
export * from "./LoginReportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports